import { trackClickIBubbleClick } from './actions';

export default {
    trackClickIBubbleClick,
};
